import PropTypes from 'prop-types';
import { Error } from '@figure/frontlib-gui';
import { Typography } from 'shared/components';
import { LI, OL } from 'shared/components/List';
import { Instruction, InstructionButtonGroup } from './';

const CheckingInstruction = ({ handleBack, handleClick, serverError }) => (
  <>
    <Typography.PageHeader>Personal Checking Account</Typography.PageHeader>
    <h3>Log into your financial institution to securely link your personal checking account. Business accounts are not eligible.</h3>
    <Instruction space="1.6rem">
      <Typography.BodyBold semanticElement="h2">What you’ll need:</Typography.BodyBold>

      <OL resetMargin={false} marginBottom="40px">
        <LI>Online account(s) for your financial institution where you receive your income</LI>
        <LI>Account login credentials</LI>
      </OL>

      <Typography.SmallBody>
        <strong>
          Important: Once directed to your financial institution, please authorize Plaid to access account information for ALL of the
          accounts you would like to link. If access is not granted, we will be unable to verify your income through this method.
        </strong>
      </Typography.SmallBody>

      <Error display="block">{serverError}</Error>

      <InstructionButtonGroup buttonText="Link checking account" handleBack={handleBack} handleClick={handleClick} />
    </Instruction>
  </>
);

CheckingInstruction.propTypes = {
  handleBack: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  serverError: PropTypes.string.isRequired,
};

export default CheckingInstruction;
